// updated by Malik - New course detail page for non-CBSE/ICSE boards
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import parse from "html-react-parser";

import { FaPlay, FaCartArrowDown, FaAngleDown } from "react-icons/fa6";
import {
  FaBookOpen,
  FaVideo,
  FaCertificate,
  FaGraduationCap,
  FaDownload,
  FaClock,
} from "react-icons/fa";
import { HiSparkles } from "react-icons/hi2";
import { FiArrowRight } from "react-icons/fi";

import AngularImg from "../../assets/images/courses/angular.jpg";
import ApiService from "../../services/ApiService";
import { ratings } from "../../data/courses-data/Ratings";
import { addToCart, fetchCartItems } from "../../store2/features/cartSlice";
import { callAlert, downloadPdfFile } from "../../services/CommonService";
import {
  setAddToCartDetails,
  setTrailDetails,
  subscriptionTrial,
} from "../../services/AuthService";
import { useScroll } from "../../router/Scroll/ScrollContext";

import AccordionComponent from "../../components/AccordionPage";
import ReviewCard from "../../components/ReviewsCard";
import CourseSlider from "../../components/CourseSlider";
import PageLoader from "../../features/PageLoader";
import Loader from "../../features/Loader";

export default function OtherCourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { scrollToSection } = useScroll();
  const { courses } = useSelector((state) => state.courses);
  const userDetailss = localStorage.getItem("userDetails");

  const [course, setCourse] = useState();
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(true);
  const [selectedCourse, setSelectedCourse] = useState("Full Course");
  const [selectedCount, setSelectedCount] = useState();
  const [customModuleList, setCustomModuleList] = useState();
  const [totalPrice, setTotalPrice] = useState();
  const [visibleItems, setVisibleItems] = useState(3);
  const [showVideoModal, setShowVideoModal] = useState(false);

  // ---------- DATA FETCH (kept identical to original) ----------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiService.publicPostRequest(
          "/courses/findcourses",
          [id],
        );
        setLoader(true);
        setCourse(response.data[0]);

        const isDesktop = window.innerWidth >= 1024;
        setTimeout(() => {
          const hash = window.location.hash;
          if (hash) {
            const element = document.getElementById(hash.replace("#", ""));
            if (element) element.scrollIntoView({ behavior: "smooth" });
          } else if (!isDesktop) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        }, 1000);
      } catch (e) {
        console.error("Error fetching courses:", e);
        setError({ message: "Course not found", url: window.location.href });
      }
      setLoader(false);
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    if (error) navigate("/custom-error", { state: { error } });
  }, [error, navigate]);

  useEffect(() => {
    document.title = course?.courseName || "Loading Course...";
  }, [course]);

  // ---------- HANDLERS (kept identical to original) ----------
  const notify = () =>
    toast.success(
      <>
        {course?.courseName} <strong>added to cart</strong>
      </>,
    );

  const selectModule = () =>
    toast.warn(
      <>
        <strong>Select at least one module</strong>
      </>,
    );

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleAddToCart = async () => {
    if (!userDetailss) {
      if (selectedCourse === "Custom Course") {
        setAddToCartDetails({
          modeClass: { courseId: course.id, moduleList: customModuleList },
        });
      } else {
        const moduleList = course.modules.map((m) => m.id);
        setAddToCartDetails({
          modeClass: { courseId: course.id, moduleList: moduleList },
        });
      }
      toast.error(
        <>
          Please <strong>login first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      if (selectedCourse === "Custom Course") {
        if (customModuleList?.length > 0) {
          scrollToSection("top");
          const result = await dispatch(
            addToCart({ courseId: course.id, moduleList: customModuleList }),
          );
          if (result.payload?.resultCode != 1) {
            callAlert("", result.payload?.message);
            return;
          }
          dispatch(fetchCartItems());
          notify();
          const timeoutId = setTimeout(() => navigate("/cart"), 2000);
          return () => clearTimeout(timeoutId);
        } else {
          selectModule();
        }
      }
      if (selectedCourse === "Full Course") {
        const moduleList = course.modules.map((m) => m.id);
        scrollToSection("top");
        const result = await dispatch(
          addToCart({ courseId: course.id, moduleList: moduleList }),
        );
        if (result.payload?.resultCode != 1) {
          callAlert("", result.payload?.message);
          return;
        }
        notify();
        const timeoutId = setTimeout(() => navigate("/cart"), 2000);
        return () => clearTimeout(timeoutId);
      }
    }
  };

  const handleAddToCartFreeTrial = async (id) => {
    navigate("/register", {
      state: {
        courseBoard: course?.board?.toLowerCase(),
        courseGrade: course?.grade?.toLowerCase(),
      },
    });
    setTrailDetails({ modeClass: id });
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>Sign up first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      subscriptionTrial(() => navigate(`/user/dashboard`, {}));
    }
  };

  const handleDownloadPDF = () => {
    downloadPdfFile(
      `/syllabus/downloadFile/file?fileName=${course?.syllabusId}`,
    );
  };

  const getYouTubeVideoId = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get("v");
    } catch {
      return "IG2zSQ27VFQ";
    }
  };

  const loadMoreItems = () => setVisibleItems((v) => v + 3);

  // ---------- DERIVED VALUES ----------
  let sessionCount = 0;
  let totalDurationSec = 0;
  if (course?.moduleList?.length > 0) {
    course.moduleList.forEach((m) => {
      if (m.contentList?.length > 0) {
        m.contentList.forEach((c) => {
          sessionCount++;
          totalDurationSec += c.duration || 0;
        });
      }
    });
  }
  const totalHours = Math.floor(totalDurationSec / 3600);
  const totalMinutes = Math.floor((totalDurationSec % 3600) / 60);

  // ---------- RENDER ----------
  if (loader || !course) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
        }}
      >
        <PageLoader />
      </div>
    );
  }

  return (
    <>
      {/* All custom styles scoped under .oc-page to avoid collisions */}
      <style>{`
        .oc-page {
          background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
          color: #0f1a3a;
        }

        /* ============ HERO ============ */
        .oc-hero {
          position: relative;
          background: linear-gradient(135deg, #1363df 0%, #0d4ba8 55%, #062a5c 100%);
          color: #ffffff;
          overflow: hidden;
          padding: 90px 0 110px;
          isolation: isolate;
        }
        .oc-hero-grid {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 48px 48px;
          mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 80%);
          pointer-events: none;
        }
        .oc-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(90px);
          opacity: 0.45;
          z-index: -1;
        }
        .oc-orb-a { width: 420px; height: 420px; background: #ffb800; top: -120px; right: -100px; animation: ocFloatA 9s ease-in-out infinite; }
        .oc-orb-b { width: 360px; height: 360px; background: #00d4ff; bottom: -160px; left: -90px; animation: ocFloatB 11s ease-in-out infinite; }
        @keyframes ocFloatA { 0%,100% { transform: translate(0,0); } 50% { transform: translate(-30px, 30px); } }
        @keyframes ocFloatB { 0%,100% { transform: translate(0,0); } 50% { transform: translate(40px, -40px); } }

        .oc-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255, 184, 0, 0.15);
          border: 1px solid rgba(255, 184, 0, 0.45);
          color: #ffd966;
          padding: 8px 18px;
          border-radius: 100px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 22px;
          backdrop-filter: blur(10px);
        }
        .oc-badge svg { color: #ffb800; }

        .oc-hero-title {
          font-size: clamp(30px, 4.6vw, 54px);
          font-weight: 800;
          line-height: 1.08;
          margin-bottom: 22px;
          letter-spacing: -1px;
          background: linear-gradient(180deg, #ffffff 0%, #c8d6f0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .oc-hero-summary {
          color: rgba(255, 255, 255, 0.88);
          font-size: 15px;
          line-height: 1.75;
          margin-bottom: 34px;
          max-width: 560px;
        }
        .oc-hero-summary ul { list-style: none; padding: 0; margin: 0; }
        .oc-hero-summary li {
          padding-left: 30px;
          position: relative;
          margin-bottom: 11px;
        }
        .oc-hero-summary li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 6px;
          width: 18px;
          height: 18px;
          background: #ffb800;
          border-radius: 50%;
          box-shadow: 0 0 0 4px rgba(255,184,0,0.18);
        }
        .oc-hero-summary li::after {
          content: "✓";
          position: absolute;
          left: 4px;
          top: 4px;
          font-size: 11px;
          font-weight: 800;
          color: #062a5c;
        }

        .oc-hero-actions { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 44px; }
        .oc-btn-primary {
          background: linear-gradient(135deg, #ffb800 0%, #ff9500 100%);
          color: #062a5c;
          padding: 16px 30px;
          border-radius: 100px;
          font-weight: 800;
          font-size: 15px;
          border: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 12px 32px rgba(255, 184, 0, 0.35);
          transition: transform .25s ease, box-shadow .25s ease;
          cursor: pointer;
        }
        .oc-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 18px 40px rgba(255, 184, 0, 0.45); }

        .oc-btn-ghost {
          background: rgba(255, 255, 255, 0.08);
          color: #ffffff;
          padding: 16px 26px;
          border-radius: 100px;
          font-weight: 600;
          font-size: 15px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          display: inline-flex;
          align-items: center;
          gap: 10px;
          backdrop-filter: blur(10px);
          transition: background .25s ease, border-color .25s ease;
          cursor: pointer;
        }
        .oc-btn-ghost:hover { background: rgba(255, 255, 255, 0.15); border-color: rgba(255, 255, 255, 0.45); }

        .oc-stats-row { display: flex; gap: 14px; flex-wrap: wrap; }
        .oc-stat {
          display: flex;
          align-items: center;
          gap: 12px;
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.12);
          padding: 12px 18px;
          border-radius: 14px;
          backdrop-filter: blur(10px);
        }
        .oc-stat-icon {
          width: 38px; height: 38px;
          border-radius: 10px;
          background: rgba(255, 184, 0, 0.15);
          color: #ffb800;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px;
        }
        .oc-stat-value { font-size: 18px; font-weight: 800; color: #fff; line-height: 1; display: block; }
        .oc-stat-label { font-size: 11px; color: rgba(255,255,255,0.65); letter-spacing: 0.6px; text-transform: uppercase; margin-top: 4px; display: block; }

        /* HERO MEDIA */
        .oc-hero-media { position: relative; z-index: 2; padding-left: 20px; }
        .oc-video-thumb {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          cursor: pointer;
          box-shadow: 0 30px 60px rgba(0,0,0,0.35);
          transform: rotate(-1.5deg);
          transition: transform .4s ease;
          background: #ffffff;
          border: 5px solid rgba(255,255,255,0.12);
        }
        .oc-video-thumb:hover { transform: rotate(0) scale(1.02); }
        .oc-video-thumb img { width: 100%; height: auto; display: block; }
        .oc-play-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(180deg, rgba(6,42,92,0.1) 40%, rgba(6,42,92,0.75) 100%);
          display: flex; align-items: center; justify-content: center;
        }
        .oc-play-btn {
          width: 82px; height: 82px;
          border-radius: 50%;
          background: #ffb800;
          color: #062a5c;
          display: flex; align-items: center; justify-content: center;
          font-size: 26px;
          box-shadow: 0 20px 40px rgba(255, 184, 0, 0.55);
          animation: ocPulse 2.2s infinite;
        }
        @keyframes ocPulse {
          0% { box-shadow: 0 0 0 0 rgba(255, 184, 0, 0.7); }
          70% { box-shadow: 0 0 0 22px rgba(255, 184, 0, 0); }
          100% { box-shadow: 0 0 0 0 rgba(255, 184, 0, 0); }
        }

        .oc-float-card {
          position: absolute;
          bottom: -22px;
          left: -22px;
          background: #ffffff;
          padding: 14px 20px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.18);
          color: #062a5c;
          font-weight: 700;
          font-size: 14px;
          z-index: 10;
        }
        .oc-float-card-icon {
          width: 42px; height: 42px;
          border-radius: 12px;
          background: linear-gradient(135deg, #1363df, #0d4ba8);
          color: #fff;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px;
        }

        .oc-float-tag {
          position: absolute;
          top: -16px;
          right: -10px;
          background: linear-gradient(135deg, #ffb800, #ff9500);
          color: #062a5c;
          font-weight: 800;
          font-size: 13px;
          padding: 10px 18px;
          border-radius: 100px;
          box-shadow: 0 12px 30px rgba(255, 184, 0, 0.4);
          transform: rotate(6deg);
          z-index: 10;
        }

        /* ============ CONTENT ============ */
        .oc-content { padding: 64px 0 80px; position: relative; }
        .oc-card {
          background: #ffffff;
          border-radius: 24px;
          padding: 44px 44px;
          margin-bottom: 28px;
          border: 1px solid #e8eef7;
          box-shadow: 0 4px 30px rgba(19, 99, 223, 0.05);
          position: relative;
          overflow: hidden;
        }
        .oc-card::before {
          content: "";
          position: absolute;
          top: 28px; left: 0;
          width: 5px; height: 56px;
          background: linear-gradient(180deg, #1363df, #ffb800);
          border-radius: 0 5px 5px 0;
        }

        .oc-section-title {
          font-size: clamp(24px, 3vw, 34px);
          font-weight: 800;
          // color: #062a5c;
          color: #1363df;
          margin-bottom: 28px;
          letter-spacing: -0.5px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .oc-section-title span {
          // background: linear-gradient(135deg, #1363df, #ffb800);
          // color: #0056b3; 
          color: #1363df;
          -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .oc-title-icon {
          width: 44px; height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, rgba(19,99,223,0.1), rgba(255,184,0,0.1));
          color: #1363df;
          display: inline-flex;
          align-items: center; justify-content: center;
          font-size: 20px;
        }

        /* PARSED HTML BLOCK */
        .oc-rich {
          color: #4a5568;
          font-size: 16px;
          line-height: 1.85;
        }
        .oc-rich p { margin-bottom: 16px; }
        .oc-rich p:last-child { margin-bottom: 0; }
        .oc-rich strong, .oc-rich b { color: #062a5c; font-weight: 700; }
        .oc-rich a { color: #1363df; text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 3px; }

        .oc-rich ul { list-style: none; padding: 0; margin: 0 0 18px 0; }
        .oc-rich ul li {
          padding-left: 34px;
          position: relative;
          margin-bottom: 12px;
          line-height: 1.7;
        }
        .oc-rich ul li::before {
          content: "";
          position: absolute;
          left: 0; top: 8px;
          width: 18px; height: 18px;
          border-radius: 50%;
          background: #ffffff;
          border: 2px solid #1363df;
          box-shadow: inset 0 0 0 3px #1363df;
        }
        .oc-rich ul ul { margin-top: 10px; margin-bottom: 0; }
        .oc-rich ul ul li::before {
          background: #ffffff;
          border-color: #ffb800;
          box-shadow: inset 0 0 0 3px #ffb800;
        }

        .oc-rich ol { padding-left: 24px; margin-bottom: 18px; }
        .oc-rich ol li { margin-bottom: 10px; line-height: 1.7; }
        .oc-rich h1, .oc-rich h2, .oc-rich h3, .oc-rich h4 {
          color: #062a5c;
          margin: 22px 0 12px;
          font-weight: 700;
        }
        .oc-rich figure.table { margin: 18px 0; overflow-x: auto; }
        .oc-rich table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          border: 1px solid #e8eef7;
          border-radius: 12px;
          overflow: hidden;
        }
        .oc-rich table td, .oc-rich table th {
          padding: 12px 16px;
          border-bottom: 1px solid #eef3fb;
          border-right: 1px solid #eef3fb;
          background: #fff;
          font-size: 14px;
        }
        .oc-rich table tr td:last-child, .oc-rich table tr th:last-child { border-right: none; }
        .oc-rich table tr:last-child td { border-bottom: none; }
        .oc-rich table tr:first-child td {
          background: linear-gradient(135deg, #f0f5ff, #ffffff);
          font-weight: 700;
          color: #062a5c;
        }

        /* ============ PRICING ============ */
        .oc-pricing {
          background: linear-gradient(135deg, #f4f8ff 0%, #ffffff 100%);
          border: 1px solid #dee8f9;
          border-radius: 24px;
          padding: 32px;
          margin-bottom: 28px;
          position: relative;
          overflow: hidden;
        }
        .oc-pricing::after {
          content: "";
          position: absolute;
          top: -40px; right: -40px;
          width: 180px; height: 180px;
          background: radial-gradient(circle, rgba(255,184,0,0.18), transparent 70%);
          pointer-events: none;
        }
        .oc-pricing-heading {
          font-size: 14px;
          font-weight: 700;
          color: #5a6788;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 16px;
        }
        .oc-toggle-buttons { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 20px; }
        .oc-toggle-btn {
          flex: 1;
          min-width: 200px;
          padding: 18px 22px;
          border-radius: 16px;
          border: 2px solid #e1e9f7;
          background: #ffffff;
          color: #062a5c;
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          transition: all .25s ease;
          text-align: left;
          display: flex; align-items: center; justify-content: space-between;
        }
        .oc-toggle-btn small { display: block; font-size: 11px; color: #8090ad; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600; margin-bottom: 4px; }
        .oc-toggle-btn .oc-tt-price { font-size: 18px; font-weight: 800; }
        .oc-toggle-btn.active {
          border-color: transparent;
          background: linear-gradient(135deg, #1363df, #0d4ba8);
          color: #ffffff;
          box-shadow: 0 12px 32px rgba(19, 99, 223, 0.28);
        }
        .oc-toggle-btn.active small,
        .oc-toggle-btn.active .oc-tt-price { color: #ffffff; }
        .oc-toggle-btn.active small { color: rgba(255,255,255,0.75); }

        .oc-cart-btn {
          background: linear-gradient(135deg, #ffb800, #ff9500);
          color: #062a5c;
          padding: 18px 32px;
          border-radius: 16px;
          font-weight: 700;
          font-size: 22px;
          border: none;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          box-shadow: 0 12px 32px rgba(255, 184, 0, 0.3);
          transition: transform .25s ease, box-shadow .25s ease;
          cursor: pointer;
        }
        .oc-cart-btn:hover { transform: translateY(-2px); box-shadow: 0 18px 40px rgba(255, 184, 0, 0.4); }

        .oc-selected-bar {
          background: #ffffff;
          border: 1px dashed #1363df;
          border-radius: 14px;
          padding: 14px 22px;
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
        }
        .oc-selected-bar h5 { margin: 0; color: #062a5c; font-weight: 700; font-size: 15px; }
        .oc-selected-bar h5 strong { color: #1363df; }

        /* ============ ACCORDION SECTION TITLE ============ */
        .oc-modules-heading {
          font-size: clamp(22px, 2.8vw, 30px);
          font-weight: 800;
          color: #062a5c;
          margin: 36px 0 18px;
          letter-spacing: -0.5px;
        }
        .oc-modules-heading span { color: #1363df; }

        /* ============ REVIEWS / RELATED (preserve original) ============ */
        .oc-page .key-highlight-title {
          font-size: clamp(24px, 3vw, 34px);
          font-weight: 800;
          // color: #062a5c;
          color: #1363df; 
          margin-bottom: 22px;
          letter-spacing: -0.5px;
        }
        .oc-page .key-highlight-title span {
          // background: linear-gradient(135deg, #1363df, #ffb800);
          // color: #0056b3; 
          color: #1363df;
          -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .oc-page .review-count { font-size: 16px; color: #8090ad; font-weight: 600; }

        /* RESPONSIVE */
        @media (max-width: 991px) {
          .oc-hero { padding: 64px 0 84px; }
          .oc-hero-media { margin-top: 44px; padding-left: 0; }
          .oc-card { padding: 28px 22px; }
          .oc-float-card { left: 10px; bottom: -16px; }
          .oc-float-tag { right: 10px; }
        }
        @media (max-width: 575px) {
          .oc-toggle-btn { min-width: 100%; }
        }


        to specially showcase the parsed HTML content from the course description, I've added styles under the .oc-rich class. This ensures that any HTML tags like paragraphs, lists, strong, etc., are styled consistently and look good within the course details page.

        /* ============ EYEBROWS & DISPLAY HEADINGS ============ */
.oc-eyebrow {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #1363df;
  background: rgba(19, 99, 223, 0.08);
  padding: 6px 14px;
  border-radius: 100px;
  margin: 28px 0 14px;
}
.oc-display-h {
  font-size: clamp(22px, 2.4vw, 28px);
  font-weight: 800;
  color: #062a5c;
  line-height: 1.25;
  margin: 0 0 18px;
  letter-spacing: -0.3px;
}
.oc-lead {
  font-size: 15.5px;
  line-height: 1.8;
  color: #4a5568;
  margin: 0 0 20px;
  max-width: 760px;
}

/* ============ STEP FLOW (1→2→3→4→5) ============ */
.oc-step-flow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin: 26px 0;
}
.oc-step-card {
  background: #ffffff;
  border: 1px solid #e8eef7;
  border-radius: 18px;
  padding: 22px 16px 20px;
  text-align: center;
  position: relative;
  box-shadow: 0 4px 18px rgba(19, 99, 223, 0.04);
}
.oc-step-card::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -16px;
  width: 18px;
  height: 2px;
  background-image: linear-gradient(to right, #cbd5e0 50%, transparent 50%);
  background-size: 5px 2px;
  background-repeat: repeat-x;
  z-index: 1;
}
.oc-step-card:last-child::after { display: none; }
.oc-step-num {
  width: 28px; height: 28px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.oc-step-num.c1 { background: #1363df; }
.oc-step-num.c2 { background: #8b5cf6; }
.oc-step-num.c3 { background: #14b8a6; }
.oc-step-num.c4 { background: #f97316; }
.oc-step-num.c5 { background: #1363df; }
.oc-step-icon {
  width: 56px; height: 56px;
  margin: 0 auto 14px;
  display: flex; align-items: center; justify-content: center;
}
.oc-step-icon svg { width: 44px; height: 44px; }
.oc-step-title {
  font-size: 15px;
  font-weight: 800;
  color: #062a5c;
  margin: 0 0 8px;
}
.oc-step-desc {
  font-size: 12.5px;
  color: #5a6788;
  line-height: 1.6;
  margin: 0;
}
@media (max-width: 991px) {
  .oc-step-flow { grid-template-columns: repeat(2, 1fr); }
  .oc-step-card::after { display: none; }
}

/* ============ FEATURE GRID (2x2 colored cards) ============ */
.oc-feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
  margin: 24px 0;
}
.oc-feature-card {
  border-radius: 20px;
  padding: 28px;
  display: flex;
  gap: 22px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(19, 99, 223, 0.04);
}
.oc-feature-card.tone-blue { background: linear-gradient(135deg, #f0f5ff, #e8eefd); }
.oc-feature-card.tone-purple { background: linear-gradient(135deg, #f3eefd, #ebe3fb); }
.oc-feature-card.tone-mint { background: linear-gradient(135deg, #e8f7f0, #d9f0e6); }
.oc-feature-card.tone-peach { background: linear-gradient(135deg, #fff1e6, #ffe6d1); }
.oc-feature-card::after {
  content: "";
  position: absolute;
  bottom: 10px; right: 14px;
  width: 84px; height: 84px;
  background-image: radial-gradient(circle, currentColor 1.5px, transparent 1.5px);
  background-size: 9px 9px;
  opacity: 0.18;
  pointer-events: none;
}
.oc-feature-card.tone-blue { color: #1363df; }
.oc-feature-card.tone-purple { color: #8b5cf6; }
.oc-feature-card.tone-mint { color: #14b8a6; }
.oc-feature-card.tone-peach { color: #f97316; }
.oc-feature-icon {
  flex: 0 0 86px;
  height: 86px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  box-shadow: 0 6px 16px rgba(0,0,0,0.05);
}
.oc-feature-icon svg { width: 40px; height: 40px; }
.oc-feature-body { flex: 1; min-width: 0; position: relative; z-index: 1; }
.oc-feature-title {
  font-size: 19px;
  font-weight: 800;
  color: #062a5c;
  margin: 0 0 6px;
  letter-spacing: -0.2px;
}
.oc-feature-desc {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.65;
  margin: 0;
}
@media (max-width: 767px) {
  .oc-feature-grid { grid-template-columns: 1fr; }
  .oc-feature-card { padding: 22px; gap: 18px; }
  .oc-feature-icon { flex-basis: 72px; height: 72px; }
}

/* ============ MINIMAL GRID (white cards with rounded-square icons) ============ */
.oc-minimal-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
  margin: 24px 0;
}
.oc-minimal-card {
  background: #ffffff;
  border: 1px solid #e8eef7;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(19, 99, 223, 0.03);
}
.oc-minimal-icon {
  width: 54px; height: 54px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f0f5ff, #e3edfd);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
}
.oc-minimal-icon.purple { background: linear-gradient(135deg, #f3eefd, #e8dffb); }
.oc-minimal-icon.mint { background: linear-gradient(135deg, #e8f7f0, #d9f0e6); }
.oc-minimal-icon svg { width: 26px; height: 26px; }
.oc-minimal-title {
  font-size: 21px;
  font-weight: 800;
  color: #062a5c;
  margin: 0 0 10px;
}
.oc-minimal-desc {
  font-size: 14.5px;
  color: #5a6788;
  line-height: 1.7;
  margin: 0;
}
@media (max-width: 767px) { .oc-minimal-grid { grid-template-columns: 1fr; } }

/* ============ PHASE GRID (4 phases) ============ */
.oc-phase-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin: 24px 0;
}
.oc-phase-card {
  background: #ffffff;
  border: 1px solid #e8eef7;
  border-radius: 16px;
  padding: 22px 20px;
  position: relative;
  overflow: hidden;
}
.oc-phase-card::before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 4px;
  background: linear-gradient(90deg, #1363df, #ffb800);
}
.oc-phase-label {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #1363df;
  background: rgba(19, 99, 223, 0.08);
  padding: 4px 12px;
  border-radius: 100px;
  margin-bottom: 12px;
}
.oc-phase-text {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.65;
  margin: 0;
}
@media (max-width: 991px) { .oc-phase-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 575px) { .oc-phase-grid { grid-template-columns: 1fr; } }

/* ============ CALLOUT (closing CTA box) ============ */
.oc-callout {
  background: linear-gradient(135deg, #1363df 0%, #0d4ba8 100%);
  border-radius: 20px;
  padding: 32px;
  color: #ffffff;
  margin: 28px 0 8px;
  position: relative;
  overflow: hidden;
}
.oc-callout::after {
  content: "";
  position: absolute;
  top: -50px; right: -50px;
  width: 180px; height: 180px;
  background: radial-gradient(circle, rgba(255,184,0,0.4), transparent 70%);
  pointer-events: none;
}
.oc-callout-h {
  color: #ffffff !important;
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 8px;
  letter-spacing: -0.2px;
}
.oc-callout-p {
  color: rgba(255,255,255,0.88);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
  max-width: 720px;
}

/* ============ PROGRAM SNAPSHOT CARD (Image 3 right side) ============ */
.oc-snapshot {
  background: linear-gradient(135deg, #f4f8ff 0%, #ffffff 60%);
  border: 1px solid #dee8f9;
  border-radius: 24px;
  padding: 36px 34px;
  position: relative;
  overflow: hidden;
  margin: 24px 0 28px;
  max-width: 580px;
}
.oc-snapshot::before {
  content: "";
  position: absolute;
  top: -40px; right: -40px;
  width: 200px; height: 200px;
  background-image: radial-gradient(circle, rgba(255,184,0,0.18), transparent 70%);
  pointer-events: none;
  z-index: 0;
}
.oc-snapshot::after {
  content: "";
  position: absolute;
  bottom: -60px; left: -60px;
  width: 220px; height: 220px;
  background-image: radial-gradient(circle, rgba(19,99,223,0.08), transparent 70%);
  pointer-events: none;
  z-index: 0;
}
.oc-snapshot > * { position: relative; z-index: 1; }

.oc-snapshot-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1.5px solid #b8e5d3;
  color: #14b8a6;
  font-size: 12.5px;
  font-weight: 800;
  padding: 7px 18px;
  border-radius: 100px;
  letter-spacing: 0.4px;
  margin-bottom: 18px;
}
.oc-snapshot-badge svg { width: 14px; height: 14px; }

.oc-snapshot-title {
  font-size: clamp(22px, 2.4vw, 28px);
  font-weight: 800;
  color: #062a5c;
  margin: 0 0 10px;
  letter-spacing: -0.3px;
}
.oc-snapshot-sub {
  font-size: 14.5px;
  color: #5a6788;
  line-height: 1.7;
  margin: 0 0 22px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e8eef7;
}
.oc-snapshot-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.oc-snapshot-item {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 15px;
  color: #1a2c4e;
  font-weight: 600;
}
.oc-snapshot-item::before {
  content: "";
  flex: 0 0 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #e8f7f0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2314b8a6' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;
}
      `}</style>

      <div className="oc-page">
        {/* ================ HERO (inline, no separate component) ================ */}
        <section className="oc-hero">
          <div className="oc-hero-grid"></div>
          <div className="oc-orb oc-orb-a"></div>
          <div className="oc-orb oc-orb-b"></div>

          <Container>
            <Row className="align-items-center">
              <Col lg={7}>
                <div>
                  {/* <span className="oc-badge">
                    <HiSparkles /> {course.board} • {course.grade}
                  </span> */}
                  <h1 className="oc-hero-title">{course.courseName}</h1>

                  <div className="oc-hero-summary">
                    {course.summary && parse(String(course.summary))}
                  </div>

                  <div className="oc-hero-actions">
                    {
                      userDetailss ?
                        <button
                          className="oc-btn-primary"
                          onClick={handleAddToCart}
                        >
                          <>
                            {" "}
                            <FaCartArrowDown /> Enroll Now •{" "}
                            <s>₹{course.discount}</s> ₹{course.price}
                          </>
                        </button>
                      : <button
                          className="oc-btn-primary"
                          onClick={handleAddToCart}
                          data-bs-toggle="modal"
                          data-bs-target="#loginModal"
                        >
                          <>
                            {" "}
                            <FaCartArrowDown /> Enroll Now •
                            <s>₹{course.discount}</s> ₹{course.price}
                          </>
                        </button>


                      // <button
                      //     className="oc-btn-primary"
                      //     onClick={() => handleAddToCartFreeTrial(course?.id)}
                      //   >
                      //     Start Free Trial <FiArrowRight />
                      //   </button>
                    }
                    {/* {course?.syllabusId && (
                      <button
                        className="oc-btn-ghost"
                        onClick={handleDownloadPDF}
                      >
                        <FaDownload /> Download Syllabus
                      </button>
                    )} */}
                  </div>

                  <div className="oc-stats-row">
                    <div className="oc-stat">
                      <div className="oc-stat-icon">
                        <FaBookOpen />
                      </div>
                      <div>
                        <span className="oc-stat-value">
                          {course?.modules?.length || 0}
                        </span>
                        <span className="oc-stat-label">Modules</span>
                      </div>
                    </div>
                    {sessionCount > 0 && (
                      <div className="oc-stat">
                        <div className="oc-stat-icon">
                          <FaVideo />
                        </div>
                        <div>
                          <span className="oc-stat-value">{sessionCount}</span>
                          <span className="oc-stat-label">Sessions</span>
                        </div>
                      </div>
                    )}
                    {totalHours > 0 && (
                      <div className="oc-stat">
                        <div className="oc-stat-icon">
                          <FaClock />
                        </div>
                        <div>
                          <span className="oc-stat-value">
                            {totalHours}h {totalMinutes}m
                          </span>
                          <span className="oc-stat-label">Content</span>
                        </div>
                      </div>
                    )}
                    <div className="oc-stat">
                      <div className="oc-stat-icon">
                        <FaCertificate />
                      </div>
                      <div>
                        <span className="oc-stat-value">Yes</span>
                        <span className="oc-stat-label">Certificate</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg={5}>
                <div className="oc-hero-media">
                  <div className="oc-float-tag">★ Bestseller</div>
                  <div
                    className="oc-video-thumb"
                    onClick={() => setShowVideoModal(true)}
                  >
                    <img
                      src={course.image || AngularImg}
                      alt={course.courseName}
                    />
                    <div className="oc-play-overlay">
                      <div className="oc-play-btn">
                        <FaPlay />
                      </div>
                    </div>
                  </div>
                  <div className="oc-float-card">
                    <div className="oc-float-card-icon">
                      <FaGraduationCap />
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "#8090ad",
                          letterSpacing: 0.5,
                          textTransform: "uppercase",
                        }}
                      >
                        Skill Level
                      </div>
                      <div>
                        {course.grade !== "python-advanced" ?
                          "Beginner Friendly"
                        : "Advanced"}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ================ CONTENT ================ */}
        <section className="oc-content">
          <Container>
            {/* ----- COURSE HIGHLIGHTS ----- */}
            {course?.description?.[0]?.head && (
              <div className="oc-card">
                <h2 className="oc-section-title">
                  <span className="oc-title-icon">
                    <HiSparkles />
                  </span>
                  Course <span>Highlights</span>
                </h2>
                <div className="oc-rich">
                  {course.description.map((item, i) => (
                    <div key={i}>{parse(String(item.head))}</div>
                  ))}
                </div>
              </div>
            )}

            {/* ----- COURSE OVERVIEW ----- */}
            {course?.description?.[0]?.para && (
              <div className="oc-card" id="course-details">
                <h2 className="oc-section-title">
                  <span className="oc-title-icon">
                    <FaBookOpen />
                  </span>
                  Course <span>Overview</span>
                </h2>
                <div className="oc-rich">
                  {course.description.map((item, i) => (
                    <div key={i}>{parse(String(item.para))}</div>
                  ))}
                </div>
              </div>
            )}

            {/* ----- PRICING & CTA ----- */}
            <div className="oc-pricing">
              {/* <div className="oc-pricing-heading">Choose your plan</div> */}
              {/* <div className="oc-toggle-buttons">
                <button
                  type="button"
                  className={`oc-toggle-btn ${selectedCourse === "Full Course" ? "active" : ""}`}
                  // onClick={handleCourseChange}
                  onClick={handleAddToCart}
                  value="Full Course"
                >
                  <span>
                    <small>Full Course</small>
                    <s>₹{course.discount}</s>{" "}
                    <span className="oc-tt-price">₹{course.price}</span>
                  </span>
                  <FiArrowRight />
                </button>
                 <button
                  type="button"
                  className={`oc-toggle-btn ${selectedCourse === "Custom Course" ? "active" : ""}`}
                  onClick={handleCourseChange}
                  value="Custom Course"
                >
                  <span>
                    <small>Pick & choose</small>
                    <span className="oc-tt-price">Custom Modules</span>
                  </span>
                  <FiArrowRight />
                </button> 
              </div> */}

              {/* {selectedCourse === "Custom Course" && (
                <div className="oc-selected-bar">
                  <h5>
                    Selected Modules: <strong>{selectedCount || 0}</strong>
                  </h5>
                  {totalPrice > 0 && (
                    <h5>
                      Total: <strong>₹{totalPrice}</strong>
                    </h5>
                  )}
                </div>
              )} */}

              <div style={{ marginTop: 18 }}>
                {userDetailss ?
                  <button
                    className="oc-cart-btn"
                    onClick={handleAddToCart}
                    title="Add to cart"
                  >
                    <s>₹{course.discount}</s>{" "}
                    <span className="oc-tt-price">₹{course.price}</span> Add to Cart <FaCartArrowDown />
                  </button>
                : <button
                    className="oc-cart-btn"
                    onClick={handleAddToCart}
                    data-bs-toggle="modal"
                    data-bs-target="#loginModal"
                    title="Add to cart"
                  >
                    <s>₹{course.discount}</s>{" "}
                    <span className="oc-tt-price">₹{course.price}</span> Add to Cart <FaCartArrowDown />
                  </button>
                }
              </div>
            </div>

            {/* ----- MODULES ACCORDION ----- */}
            <h3 className="oc-modules-heading">
              {/* Course <span>Modules</span> */}
              <span>Course Modules</span>
            </h3>
            <div className="accordion-wrapper mb-4">
              <AccordionComponent
                courseModule={course.moduleList}
                selectedCourse={selectedCourse}
                setCustomModuleList={setCustomModuleList}
                setTotalPrice={setTotalPrice}
                setSelectedCount={setSelectedCount}
              />
            </div>

            {/* ================ CUSTOMER REVIEWS (kept identical) ================ */}
            <Row>
              <Col sm={12}>
                <div className="course-page-content">
                  <h2 className="key-highlight-title pt-4">
                    Customer <span>Reviews </span>{" "}
                    <span className="review-count">( {ratings.length} )</span>
                  </h2>

                  <Row>
                    {ratings.slice(0, visibleItems).map((rating, index) => (
                      <Col key={index} md={4} className="mb-3">
                        <ReviewCard rating={rating} />
                      </Col>
                    ))}
                  </Row>
                  {visibleItems < ratings.length && (
                    <Row>
                      <div className="col-md-4 offset-md-4 mt-3">
                        <div className="text-center d-grid ">
                          <button
                            className="btn btn-primary btn-lg"
                            onClick={loadMoreItems}
                          >
                            View More <FaAngleDown />
                          </button>
                        </div>
                      </div>
                    </Row>
                  )}
                </div>
              </Col>
            </Row>

            {/* ================ RELATED COURSES (kept identical) ================ */}
            <Row>
              <Col sm={12}>
                <div className="course-page-content">
                  <h2 className="key-highlight-title pt-4">
                    Related <span>Courses</span>
                  </h2>

                  {courses.length === 0 ?
                    <Loader />
                  : <CourseSlider dataCourse={courses} />}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ================ VIDEO MODAL ================ */}
        <Modal
          show={showVideoModal}
          onHide={() => setShowVideoModal(false)}
          animation={false}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{course.courseName} • Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-1">
            <iframe
              width="100%"
              height="420"
              src={
                "https://www.youtube.com/embed/" +
                (course.video ? getYouTubeVideoId(course.video) : "IG2zSQ27VFQ")
              }
              title={course.courseName}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
